import { useQuery } from '@tanstack/react-query';
import { getProductConditions } from '../service/getProductConditions';

export const getProductConditionsQuery = (token?: string) => {
  const {
    data: conditions,
    error: isError,
    isLoading: isConditionLoading,
  } = useQuery({
    queryKey: ['productCondition', token],
    queryFn: ({ queryKey }) => {
      const [, token] = queryKey;
      return getProductConditions(token as string);
    },
    enabled: !!token,
  });

  return { conditions, isError, isConditionLoading };
};
